import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  "@global": {
    "@keyframes slideIn": {
      " 0%": {
        transform: "translateY(100%)",
      },
      " 100%": {
        transform: "translateX(0)",
      },
    },
  },
  page: {
    padding: 20,
  },
  background: {
    backgroundColor: theme.palette.background.paper,
    "& .MuiPaper-root ": {
      borderRadius: 10,
    },
    // '& .MuiPaper-root ': {
    //   boxShadow: 'none',
    //   borderRadius:20,
    //   backgroundColor:theme.palette.background.default
    // },

    "& .MuiTable-root": {
      color: theme.palette.text.textPrimary,

      "& .MuiTableHead-root": {
        "& .MuiTableRow-head": {
          "& .MuiTableCell-head": {
            // color: theme.palette.primary.main,
            backgroundColor: theme.palette.background.default,
          },
        },
      },
      "& .MuiTableRow-root": {
        "&:nth-child(even)": {
          // backgroundColor: theme.palette.background.paper,
        },
      },
    },
    //width:"100%",
    minWidth: "80%",
    maxWidth: "90%",
    minHeight: "400px",
    borderRadius: 30,
    // animation: "1.5s ease-out 0s 1 slideIn  ",
    padding: "10px 10px",
    [theme.breakpoints.between("xs", "sm")]: {
      minWidth: "97%",
    },
  },
  center: {
    display: "flex",
    justifyContent: "center",
  },
  imgBox: {
    display: "flex",
    justifyContent: "center",
    marginTop: 20,
    marginBottom: 20,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 20,
    padding: 20,
    color: "white",
    textAlign: "center",
    transition: "background 1s, color 2s",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 30,
  },
  form: {
    display: "grid",
    width: "100%",
    // backgroundColor:"#fafafa",
    // borderRadius:"20px",
    gridTemplateColumns: "350px 350px",

    padding: "10px 20px",
    justifyContent: "left",

    gridColumnGap: "30px",
    [theme.breakpoints.between("xs", "md")]: {
      gridTemplateColumns: "auto",

      justifyContent: "center",
      alignItems: "center",
    },

    color: "secondry",
  },

  filed: {
    maxWidth: 400,

    width: 350,

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        // borderColor: theme.palette.secondary.main,
        borderRadius: 15,
      },
    },

    [theme.breakpoints.between("xs", "sm")]: {
      width: "270px",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "400px",
    },
  },

  btn: {
    maxWidth: 400,

    width: 300,
    borderRadius: 15,

    marginTop: "30px",

    [theme.breakpoints.between("xs", "sm")]: {
      width: "270px",
    },

    [theme.breakpoints.between("sm", "md")]: {
      width: "400px",
    },
    transition: "background 1s, color 2s",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: "white",
    },
  },
}));
